import {createTheme, ThemeProvider} from '@mui/material';
import {createRoot} from 'react-dom/client';
import App from './App';
import './main.scss';

const container = document.getElementById('root');

if (!container) {
    throw new Error('Root element missing');
}

const theme = createTheme({
    palette: {
        primary: {
            main: '#347B97',
        },
    },
});

const root = createRoot(container);
root.render(
    <ThemeProvider theme={theme}>
        <App />
    </ThemeProvider>,
);
